import React from 'react';
import PropTypes from 'prop-types';

export const FingerSize = ({ 
    fingerSize, 
    onChange, 
    disabled = false, 
    options = [
        "3.00", "3.25", "3.50", "3.75", "4.00", "4.25", "4.50", "4.75", 
        "5.00", "5.25", "5.50", "5.75", "6.00", "6.25", "6.50", "6.75", 
        "7.00", "7.25", "7.50", "7.75", "8.00", "8.25", "8.50", "8.75", 
        "9.00", "9.25", "9.50", "9.75", "10.00", "10.25", "10.50", "10.75", 
        "11.00", "11.25", "11.50", "11.75", "12.00", "12.25", "12.50", "12.75", 
        "13.00", "13.25", "13.50", "13.75", "14.00", "14.25", "14.50", "14.75"
    ],
    labelName = "Finger Size"
}) => {
    return (
        <div className="col-12 finger-size-selector" style={{ padding: "5px" }}>
            <label className="control-label" htmlFor="finger-size-select">
                <span style={{color:`red`}}>*</span>{labelName}:
            </label>
            <select
                id="finger-size-select"
                className="form-control"
                value={fingerSize}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                aria-label={labelName}
            >
                <option value="" disabled>
                    Select a size
                </option>
                {options.map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </select>
        </div>
    );
};

// Prop Types Validation
FingerSize.propTypes = {
    fingerSize: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string),
    labelName: PropTypes.string,
};

// Default Props
FingerSize.defaultProps = {
    fingerSize: "",
    disabled: false,
    options: [
        "3.00", "3.25", "3.50", "3.75", "4.00", "4.25", "4.50", "4.75", 
        "5.00", "5.25", "5.50", "5.75", "6.00", "6.25", "6.50", "6.75", 
        "7.00", "7.25", "7.50", "7.75", "8.00", "8.25", "8.50", "8.75", 
        "9.00", "9.25", "9.50", "9.75", "10.00", "10.25", "10.50", "10.75", 
        "11.00", "11.25", "11.50", "11.75", "12.00", "12.25", "12.50", "12.75", 
        "13.00", "13.25", "13.50", "13.75", "14.00", "14.25", "14.50", "14.75"
    ],
    labelName: "Finger Size",
};
